/**
 * Care Package
 *
 * Components and hooks for care tracking, symptoms, medications,
 * calendar, and health records.
 *
 * Provides calendar data management for the Care screen:
 * - Medications, appointments, period tracking, fertile window
 * - Unified CalendarItem model
 * - API integration hooks
 */

export { CareProvider, useCare } from "./CareContext";
export * from "./calendar.types";
export * from "./appointment-duration";
export * from "./medication-route";
// Re-export useCalendarData excluding names that are already
// exported by ./hooks (CreateSymptomPayload, useLogMedicationDose)
export {
  calendarKeys,
  type ApiSymptom,
  type UseCalendarDataOptions,
  type UseCalendarDataResult,
  useCalendarData,
  type CreateMedicationPayload,
  useCreateMedication,
  type UpdateMedicationPayload,
  useUpdateMedication,
  useDeleteMedication,
  type CreateAppointmentPayload,
  useCreateAppointment,
  type UpdateAppointmentPayload,
  useUpdateAppointment,
  useDeleteAppointment,
  type LogPeriodPayload,
  type LogPeriodResult,
  useLogPeriod,
  type CreateSymptomsPayload,
  useSymptoms,
  useCreateSymptom,
  useCreateSymptoms,
  useDeleteSymptom,
  type LogMedicationDosePayload,
  type LogMedicationDoseResult,
  useMedicationDoseLogs,
  type MedicationDoseStatus,
  type LocalMedicationDoseLog,
} from "./useCalendarData";
export * from "./useNotifications";
export * from "./useReminders";
export * from "./medications";
export * from "./records";
export * from "./hooks";
export * from "./education";
export * from "./cryovault";

// Shared treatment-domain types live in ./treatment-phases and are imported
// directly via "@louise/care/treatment-phases".
export {
  OPENED_VIAL_WINDOW_DAYS,
  useOpenedVialEvidence,
  vialEvidenceMatters,
} from "./useOpenedVialEvidence";
